import styled from '@emotion/styled';

import MuiDatePicker from '../../MuiFields/DatePicker';

import RangeMenu from './RangeMenu';

const Container = styled.div`
  display: flex;
  gap: 2rem;
`;

const RangeList = styled.div`
  /* display: flex;
  flex-direction: column; */
  min-width: fit-content;
  width: 30%;
`;

const DateForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex-grow: 1;
`;

const RangePicker = ({ id, date = {}, handleChange }) => {

  let dateObj = date;

  const changeHandler = (e, field) => {
    handleChange(e, id, field, "date") 
  } 

  return (
    <Container>
      <RangeList>
        <RangeMenu id={id} handleChange={handleChange} />
      </RangeList>
      <DateForm>
        <MuiDatePicker 
          label="Start Date" 
          name="startDate"
          value={dateObj["$gte"] || null} 
          onChange={(e) => changeHandler(e, "$gte")} 
        />
        <MuiDatePicker 
          label="End Date" 
          name="endDate" 
          value={dateObj["$lte"] || null} 
          onChange={(e) => changeHandler(e, "$lte")} 
        />
      </DateForm>
    </Container>
  )

};

export default RangePicker;